import { Popover, Tooltip } from '@tecsinapse/cortex-react'
import React from 'react'
import { FaRegCopy } from 'react-icons/fa'
import { copyToClipboardVariants } from '@web/modules/core/styles/copyToClipboardVariants'

interface CopyToClipboardProps {
  copyData: string
  enable: boolean
  onMouseOver: () => void
  onMouseLeave: () => void
  handleCopy: (data: string) => void
  size?: 'small' | 'medium' | 'large'
}

const { container, icon, popover } = copyToClipboardVariants()

const CopyToClipboard = ({ copyData, handleCopy, enable, onMouseOver, onMouseLeave, size }: CopyToClipboardProps) => {
  return (
    <div className={container()}>
      {enable ? (
        <Popover.Root trigger='click'>
          <Popover.Trigger>
            <Tooltip
              text='Copiar'
              placement='bottom'
            >
              <FaRegCopy
                className={icon({ size })}
                onClick={() => handleCopy(copyData)}
                onMouseOver={onMouseOver}
                onMouseLeave={onMouseLeave}
              />
            </Tooltip>
          </Popover.Trigger>
          <Popover.Content className={popover()}>
            <p>Copiado!</p>
          </Popover.Content>
        </Popover.Root>
      ) : (
        <></>
      )}
    </div>
  )
}

export default CopyToClipboard
